import { call, put, select, takeLatest } from "redux-saga/effects";
import factory from "utils/getApiHandlerEffect";
import { selectActivationCode } from "scenes/selectors";
import { SagaIterator } from "redux-saga";
import {
  afterSecurityMethodFetch,
  loadSecurityMethods,
  setError,
} from "./redux";
import { SecurityMethodTypes } from "./types";

export function* onLoad(): SagaIterator<void> {
  const apiHandler = yield call(() => factory());
  const activationCode = yield select(selectActivationCode);

  try {
    const SecurityMethods: { authenticators: Array<SecurityMethodTypes> } =
      yield call(() => apiHandler.getSecurityMethods(activationCode));

    const emailItem = SecurityMethods.authenticators.find(
      (item) => item.type === "email"
    );
    const newList = emailItem
      ? SecurityMethods.authenticators.filter((l) => l.type !== emailItem?.type)
      : SecurityMethods.authenticators;

    if (emailItem) {
      newList.push(emailItem as SecurityMethodTypes);
    }
    yield put(
      afterSecurityMethodFetch(
        emailItem ? newList : SecurityMethods.authenticators
      )
    );
  } catch (e: any) {
    if (e.statusCode === 400) {
      yield put(afterSecurityMethodFetch([]));
    } else {
      yield put(setError(true));
    }
  }
}

// watcher function
export default function* securitySetUpSaga() {
  yield takeLatest(loadSecurityMethods.type, onLoad);
}
